// import React, { forwardRef, useState, useEffect } from "react";
import React, { useState, useEffect } from "react";
// import "../../components/CommonStyle.css";
// import "./FindMember.css";
// import CalendarImg from "../../Images/calendar.png";
// import "react-datepicker/dist/react-datepicker.css";
// import InputFieldLargeDisabled from "../StyledComp/InputFieldLargeDisabled";
import MemberServices from "../../services/MemberServices";
import PositionServices from "../../services/PositionServices";
import CommitteeServices from "../../services/CommitteeServices";
// import DateFieldLargeDisabled from "../StyledComp/DateFieldLargeDisabled";
// import InputFieldSmallDisabled from "../StyledComp/InputFieldSmallDisabled";
// import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { useAppSelector } from "../../store/hooks";
import { useDispatch } from "react-redux";
// import { changeCurrentMemberMenu } from "../../store/screenSlice";
// import { screenConfig } from "../../config/screenConfig";
import { Button, Label, PageLink } from "../StyledComp/StyledComp";
import "../../Styles/memberModal.css";
import MDSectionsMultipleOptionItems from "./MDSectionsMultipleOptionItems";
import {
  assignCurrentMember,
  updateCurrentMember,
} from "../../store/currentMemberSlice";
import ReactModal from "react-modal";
import MDEditSectionMultipleOptionItems from "./MDEditSectionMultipleOptionItems";
import OrderServices from "../../services/OrderServices";
// import { Link, useNavigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import ButtonWithIcon from "../StyledComp/ButtonWithIcon";
// import OrderIcon from "../../Images/MenuIconComp/OrderIcon";
// import { Controller, useForm } from "react-hook-form";
import { useForm } from "react-hook-form";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import dayjs, { Dayjs } from "dayjs";
import dayjs from "dayjs";

import {
  initalOrderItem,
  IOrderItem,
  // resetOrderParameters,
  storeAddOrderItem,
  storeResetOrder,
  storeUpdateOrder,
} from "../../store/orderApiSlice";
import { updateMember_Sections } from "../../store/memberApiSlice";
import { IPaymentInfo } from "../../store/memberInterfaceStruct";
import InvoiceServices from "../../services/InvoiceServices";
import AlertWithModal from "../utilityComponents/AlertWithModal";

// interface MemberCode {
//   [key: string]: any;
// }
// interface Memberype {
//   [key: string]: any;
// }
// interface SectionData {
//   [key: string]: any;
// }

interface IConfiguration {
  [key: string]: any;
}

interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  isSelected: boolean;
  Status: boolean;
  HasSectionOfficerResponsibility?: boolean;
}

interface ISelectedSections {
  Id: number | null;
  SectionName: string | null;
  MemberId: number | null;
  MemberSectionId: number | null;
}

// interface IProps {
//   MemberCode: MemberCode[];
//   MemberType: Memberype[];
//   Sections: SectionData[];
// }

interface IMemberShipOrders {
  Id: number | null;
  OrderId: number | null;
  MemberId: number | null;
  MemberCodeId: number | null;
  LastYearSections: string | null;
  CurrentYearSections: string | null;
  CurrentYearSectionsNotPaid: string | null;
  Description: string | null;
  Fee: number | null;
  MemberCode: string | null;
}

const MDSections: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentMember = useAppSelector((state) => state.currentMember);

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const orderInfo = useAppSelector((store) => store.orderapislice);

  const SelectedSections = currentMember.MemberSections;

  // Unfiltered by enrollment date range (unlike SelectedSections) — used only to resolve a
  // MemberSectionId for the Section Positions / Section Committees widgets below, so those
  // still work for a section whose EnrollmentValidTo has lapsed but hasn't been renewed yet.
  const AllMemberSections = currentMember.AllMemberSections;

  const sectionArray = SelectedSections?.map((section: any) => {
    return section.Id;
  });

  const [selectedItems, setSelectedItems] = useState<
    (number | null)[] | undefined
  >(sectionArray);

  // Keep selectedItems in sync with current member's active sections when the member updates
  useEffect(() => {
    const arr = SelectedSections?.map((s: any) => s.Id) || [];
    setSelectedItems(arr);
  }, [SelectedSections]);

  const [sectionOfficerResponsibility, setSectionOfficerResponsibility] =
    useState<{ [key: number]: boolean }>({});

  // memberPositions: keyed by MemberSectionId → array of { Id (assignment id), PositionId, PositionName }
  const [memberPositions, setMemberPositions] = useState<{
    [memberSectionId: number]: { Id: number; PositionId: number; PositionName: string }[];
  }>({});

  // availablePositions: keyed by SectionId → array of { Id, Name }
  const [availablePositions, setAvailablePositions] = useState<{
    [sectionId: number]: { Id: number; Name: string }[];
  }>({});

  // memberCommittees: keyed by MemberSectionId → array of { Id (assignment id), CommitteeId, CommitteeName, Role }
  const [memberCommittees, setMemberCommittees] = useState<{
    [memberSectionId: number]: { Id: number; CommitteeId: number; CommitteeName: string; Role: string }[];
  }>({});

  // availableCommittees: keyed by SectionId → array of { Id, Name, Type }
  const [availableCommittees, setAvailableCommittees] = useState<{
    [sectionId: number]: { Id: number; Name: string; Type: string }[];
  }>({});

  const [orderItem, setOrderItem] = useState<IOrderItem>({
    ...initalOrderItem,
  });

  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );

  const [MembersActiveOrders, setMembersActiveOrders] = useState<
    IMemberShipOrders[]
  >([]);
  const [lastYearSections, setLastYearSections] = useState<string>("");

  const [IsActiveOrdersDataLoaded, setIsActiveOrdersDataLoaded] =
    useState<boolean>(false);

  const [sessionEditModalOpen, setSessionEditModalOpen] = useState(false);
  const [createOrderModalOpen, setCreateOrderModalOpen] = useState(false);
  const [viewInvoiceModalOpen, setViewInvoiceModalOpen] = useState(false);
  const [invoiceURL, setinvoiceURL] = useState<string>("");
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [sectionRefreshKey, setSectionRefreshKey] = useState(0);

  const formPaymentInfo = useForm<IPaymentInfo>();
  const {
    // register: registerPI,
    // control: controlPI,
    handleSubmit: handleSubmitPI,
    // formState: formStatePI,
    // setValue: setValuePI,
    // clearErrors: clearErrorsPI,
  } = formPaymentInfo;

  // Helper to load member orders (active sections) for the member
  const loadMemberOrders = async (memberId?: number | null) => {
    if (!memberId) return;
    try {
      const response = await OrderServices.getOrderByMemberId(memberId);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        setMembersActiveOrders(response.data.data.memberShipOrderDetails);
        setIsActiveOrdersDataLoaded(true);
      } else {
        setIsActiveOrdersDataLoaded(true);
      }
    } catch (error) {
      setIsActiveOrdersDataLoaded(true);
      // Handle errors from the API call
    }
  };

  useEffect(() => {
    const getConfigurationLists = async () => {
      const response = await MemberServices.getConfigurationList();
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        setConfigurationLists(response.data.data);
      }
    };

    getConfigurationLists();

    // load current member orders and last year sections
    loadMemberOrders(currentMember.Id);

    const getLastYearSection = async () => {
      try {
        const response = await MemberServices.getLastYearSections(
          currentMember.Id!
        );
        if (response.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          setLastYearSections(response.data.result[0].CurrentYearSections);
          dispatch(
            updateCurrentMember({
              key: "lastYearSections",
              value: response.data.result[0].CurrentYearSections,
            })
          );
        } else {
          alert(response.data.errors);
        }
      } catch {
        // Error handled
      }
    };

    getLastYearSection();
  }, [currentMember.Id, dispatch]);

  useEffect(() => {
    // Keep effect focused on selectedItems -> update member sections and order state.
    dispatch(updateMember_Sections(selectedItems as number[]));

    setOrderItem((prevOrderItem) => ({
      ...prevOrderItem,
      CurrentYearSections: selectedItems,
    }));

    dispatch(
      storeUpdateOrder({
        key: "HasSectionOrderItem",
        value: true,
      })
    );
  }, [selectedItems, dispatch]);

  // Initialize officer responsibility state from current member sections
  useEffect(() => {
    if (SelectedSections && SelectedSections.length > 0) {
      const officerResponsibilityMap: { [key: number]: boolean } = {};
      SelectedSections.forEach((section: any) => {
        if (section.Id) {
          officerResponsibilityMap[section.Id] =
            section.HasSectionOfficerResponsibility || false;
        }
      });
      setSectionOfficerResponsibility(officerResponsibilityMap);
    }
  }, [SelectedSections]);

  // Load member's assigned positions and available positions per section
  useEffect(() => {
    if (!currentMember?.Id) return;

    let cancelled = false;

    const loadPositions = async () => {
      try {
        // Load this member's current position assignments
        const assignResponse = await PositionServices.getMemberPositions(currentMember.Id!);
        if (cancelled) return;

        if (assignResponse.data?.data) {
          const posMap: { [memberSectionId: number]: { Id: number; PositionId: number; PositionName: string }[] } = {};
          assignResponse.data.data.forEach((row: any) => {
            if (!posMap[row.MemberSectionId]) posMap[row.MemberSectionId] = [];
            posMap[row.MemberSectionId].push({
              Id: row.Id,
              PositionId: row.PositionId,
              PositionName: row.PositionName,
            });
          });
          setMemberPositions(posMap);
        }

        // Load available positions for each section the member belongs to (unfiltered by
        // enrollment date range, so this still works for a lapsed-but-not-renewed section)
        if (AllMemberSections && AllMemberSections.length > 0) {
          const availMap: { [sectionId: number]: { Id: number; Name: string }[] } = {};
          await Promise.all(
            AllMemberSections.map(async (section: any) => {
              if (section.Id && !availMap[section.Id]) {
                const posResponse = await PositionServices.getPositions(section.Id);
                if (posResponse.data?.data) {
                  availMap[section.Id] = posResponse.data.data.map((p: any) => ({
                    Id: p.Id,
                    Name: p.Name,
                  }));
                }
              }
            })
          );
          if (cancelled) return;
          setAvailablePositions(availMap);
        }
      } catch (err) {
        if (!cancelled) console.error("Failed to load positions", err);
      }
    };

    loadPositions();

    return () => {
      cancelled = true;
    };
  }, [currentMember?.Id, AllMemberSections]);

  // Load member's assigned committee/subcommittee chair roles and available committees per section
  useEffect(() => {
    if (!currentMember?.Id) return;

    let cancelled = false;

    const loadCommittees = async () => {
      try {
        // Load this member's current committee chair assignments
        const assignResponse = await CommitteeServices.getMemberCommittees(currentMember.Id!);
        if (cancelled) return;

        if (assignResponse.data?.data) {
          const committeeMap: { [memberSectionId: number]: { Id: number; CommitteeId: number; CommitteeName: string; Role: string }[] } = {};
          assignResponse.data.data.forEach((row: any) => {
            if (!committeeMap[row.MemberSectionId]) committeeMap[row.MemberSectionId] = [];
            committeeMap[row.MemberSectionId].push({
              Id: row.Id,
              CommitteeId: row.CommitteeId,
              CommitteeName: row.CommitteeName,
              Role: row.Role,
            });
          });
          setMemberCommittees(committeeMap);
        }

        // Load available committees/subcommittees for each section the member belongs to
        // (unfiltered by enrollment date range, so this still works for a lapsed-but-not-renewed section)
        if (AllMemberSections && AllMemberSections.length > 0) {
          const availMap: { [sectionId: number]: { Id: number; Name: string; Type: string }[] } = {};
          await Promise.all(
            AllMemberSections.map(async (section: any) => {
              if (section.Id && !availMap[section.Id]) {
                const committeeResponse = await CommitteeServices.getCommittees(section.Id);
                if (committeeResponse.data?.data) {
                  availMap[section.Id] = committeeResponse.data.data.map((c: any) => ({
                    Id: c.Id,
                    Name: c.Name,
                    Type: c.Type,
                  }));
                }
              }
            })
          );
          if (cancelled) return;
          setAvailableCommittees(availMap);
        }
      } catch (err) {
        if (!cancelled) console.error("Failed to load committees", err);
      }
    };

    loadCommittees();

    return () => {
      cancelled = true;
    };
  }, [currentMember?.Id, AllMemberSections]);

  // Create immutable sections array with isSelected flag, preserving all original properties including Fee
  const Sections = React.useMemo(() => {
    if (typeof configurationList.MemberSection === "undefined") {
      return [];
    }

    return configurationList.MemberSection.map((section: ISection) => {
      const matchedMemberSection = SelectedSections?.find((s: any) => s.Id === section.Id);
      const matchedAllMemberSection = AllMemberSections?.find((s: any) => s.Id === section.Id);

      return {
        ...section,
        isSelected: !!matchedMemberSection,
        MemberSectionId: matchedAllMemberSection?.MemberSectionId ?? matchedMemberSection?.MemberSectionId ?? null,
      };
    });
  }, [configurationList.MemberSection, SelectedSections, AllMemberSections]);

  // const openMemberEditSectionInfoScreen = () => {
  //   dispatch(changeCurrentMemberMenu(screenConfig.memberEditSessionInfoScreen));
  // };

  const handleCancel = () => {
    setCreateOrderModalOpen(false);
    navigate("/member/findmember", { replace: true });
  };

  const toCamelCase = (str: string) => {
    if (!str) {
      return ""; // or handle it based on your use case
    }
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word: string, index: number) => {
        return index === 0 ? word.toUpperCase() : word.toLowerCase();
      })
      .replace(/\s+/g, "");
  };

  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    section: ISection
  ) => {
    // if (typeof Sections != "undefined") {
    //   Sections.map((section1: ISection) => {
    //     if (section1.Id == section.Id) {
    //       section1.Status = section.Status;
    //     }
    //   });
    // }

    if (event.target.checked) {
      setSelectedItems((selectedItems) => [
        ...selectedItems!,
        Number(event.target.id),
      ]);
      setTotalAmount((preTotalAmount) => preTotalAmount + section.Fee);
    } else {
      setSelectedItems((selectedItems) =>
        selectedItems!.filter((item) => {
          return item !== Number(event.target.id);
        })
      );
      setTotalAmount((preTotalAmount) => preTotalAmount - section.Fee);
    }
  };

  // Note: This useEffect is part of the old order creation flow
  // For the section removal flow, totalAmount isn't actively used
  // useEffect(() => {
  //   dispatch(
  //     storeAddOrderItem({
  //       key: "Orders",
  //       value: orderItem,
  //     })
  //   );
  //   dispatch(
  //     storeUpdateOrder({
  //       key: "TransactionAmount",
  //       value: totalAmount,
  //     })
  //   );
  // }, [orderItem, totalAmount, dispatch]);

  const onSaveSections = async (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    // Confirm intent: removing sections is destructive w.r.t. enrollment (not payments)
    const proceed = window.confirm(
      "Remove selected sections from this member? This will not reverse any paid orders. Proceed?"
    );
    if (!proceed) return;

    const response = await MemberServices.editMemberSections({
      MemberId: currentMember?.Id,
      Sections: selectedItems,
    });
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("Sections updated successfully");
      dispatch(assignCurrentMember(response.data.data[0]));

      // Refresh active orders and last-year sections so the main view updates
      // Wait for loadMemberOrders to complete before closing modal
      await loadMemberOrders(currentMember.Id);
      try {
        const resp = await MemberServices.getLastYearSections(
          currentMember.Id!
        );
        if (resp && resp.data && !resp.data.hasErrors) {
          setLastYearSections(resp.data.result[0].CurrentYearSections);
          dispatch(
            updateCurrentMember({
              key: "lastYearSections",
              value: resp.data.result[0].CurrentYearSections,
            })
          );
        }
      } catch (err) {
        console.error("Error refreshing last year sections", err);
      }
      // Force re-render of sections by changing the key
      setSectionRefreshKey((prev) => prev + 1);
    }
    setSessionEditModalOpen(false);
  };

  const onSubmitOrderInfo = async (e: any) => {
    // e.preventDefault();
    const apiBody: any = orderInfo;
    try {
      const response = await OrderServices.createOrder(apiBody);
      if (response != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        setCreateOrderModalOpen(false);
        const apiBody1: any = {
          orderId: response.data.data.insertId,
          memberId: orderInfo.MemberId,
          paymentStaus: 1, //invoice created
        };
        if (
          currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
          currentMember.MemberCodeId === 21 ||
          currentMember.MemberCodeId === 22
        ) {
          navigate("/member/findmember", { replace: true });
          return;
        } else {
          const response1 =
            await InvoiceServices.createMembershipOrderInvoiceSync(apiBody1);
          if (response1.data.data && response1.data.data.length > 0) {
            if (response.data.hasErrors) {
              setShowAlertModal(true);
              setAlertTitle("Database Error");
              setAlertBody(response.data.errors[0].sqlMessage);
              return;
            }
            setinvoiceURL(response1.data.data[0].InvoiceUrl);
            setViewInvoiceModalOpen(true);
          }
        }
        // alert("Order Created successfully");
        // dispatch(resetOrderParameters());  I am doing this in useEffect
        // navigate("/order", { replace: true });
        // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
        // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
        // dispatch(
        //   storeUpdateOrder({
        //     key: "TransactionAmount",
        //     value: 0,
        //   })
        // );
        // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
        // navigate("/member/findmember", { replace: false });
        // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
        //  dispatch(screenChange("Events"));
      }
    } catch (error) {
      console.error("ORDER: Error creating order:", error);
    }
  };

  const handleCancelViewInvoiceModal = () => {
    setViewInvoiceModalOpen(false);
    navigate("/member/findmember", { replace: true });
  };

  const handleSendInvoice = async () => {
    if (
      currentMember.PrimaryAddress &&
      currentMember.PrimaryAddress.Email === null &&
      currentMember.PublishedAddress &&
      currentMember.PublishedAddress.Email === null
    ) {
      alert("Email ID missing");
      return;
    }
    let body = {
      InvoiceLink: invoiceURL,
      FirstName: currentMember && currentMember.FirstName,
      LastName: currentMember && currentMember.LastName,
      Esquired: currentMember && currentMember.Esquire,
      MemberEmail:
        currentMember.PrimaryAddress && currentMember.PrimaryAddress.Email
          ? currentMember.PrimaryAddress.Email
          : currentMember.PublishedAddress &&
            currentMember.PublishedAddress.Email,
    };

    const response = await MemberServices.sendInvoiceEmailToMember(body);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("Mail Sent Successfully");
      // navigate("/member", { replace: false });
    }
    handleCancelViewInvoiceModal();
  };

  const handleOfficerResponsibilityChange = async (
    sectionId: number,
    hasResponsibility: boolean
  ) => {
    // update UI immediately
    setSectionOfficerResponsibility(prev => ({
        ...prev,
        [sectionId]: hasResponsibility,
    }));

    try {
        // 2. Call backend
        await MemberServices.updateOfficerResponsibility({
            MemberId: currentMember?.Id,
            SectionId: sectionId,
            HasSectionOfficerResponsibility: hasResponsibility,
        });
    } catch (err) {
        console.error(err);

        // 3. Roll back on failure
        setSectionOfficerResponsibility(prev => ({
        ...prev,
        [sectionId]: !hasResponsibility,
        }));
    }
  };

  const handleAssignPosition = async (memberSectionId: number, positionId: number) => {
    try {
      const response = await PositionServices.assignMemberPosition({ MemberSectionId: memberSectionId, PositionId: positionId });
      if (response.data?.data) {
        const newAssignment = response.data.data;
        const posName = Object.values(availablePositions)
          .flat()
          .find((p) => p.Id === positionId)?.Name || "";
        setMemberPositions((prev) => ({
          ...prev,
          [memberSectionId]: [
            ...(prev[memberSectionId] || []),
            { Id: newAssignment.Id, PositionId: positionId, PositionName: posName },
          ],
        }));
      }
    } catch (err) {
      console.error("Failed to assign position", err);
      alert("Failed to assign position.");
    }
  };

  const handleRemovePosition = async (memberSectionId: number, assignmentId: number) => {
    try {
      await PositionServices.removeMemberPosition(assignmentId);
      setMemberPositions((prev) => ({
        ...prev,
        [memberSectionId]: (prev[memberSectionId] || []).filter((a) => a.Id !== assignmentId),
      }));
    } catch (err) {
      console.error("Failed to remove position", err);
      alert("Failed to remove position.");
    }
  };

  const handleAssignCommittee = async (memberSectionId: number, committeeId: number, role: "Chair" | "Co-Chair") => {
    try {
      const response = await CommitteeServices.assignMemberCommittee({
        MemberSectionId: memberSectionId,
        CommitteeId: committeeId,
        Role: role,
      });
      if (response.data?.data) {
        const newAssignment = response.data.data;
        const committeeName = Object.values(availableCommittees)
          .flat()
          .find((c) => c.Id === committeeId)?.Name || "";
        setMemberCommittees((prev) => ({
          ...prev,
          [memberSectionId]: [
            ...(prev[memberSectionId] || []),
            { Id: newAssignment.Id, CommitteeId: committeeId, CommitteeName: committeeName, Role: role },
          ],
        }));
      }
    } catch (err) {
      console.error("Failed to assign committee", err);
      alert("Failed to assign committee.");
    }
  };

  const handleRemoveCommittee = async (memberSectionId: number, assignmentId: number) => {
    try {
      await CommitteeServices.removeMemberCommittee(assignmentId);
      setMemberCommittees((prev) => ({
        ...prev,
        [memberSectionId]: (prev[memberSectionId] || []).filter((a) => a.Id !== assignmentId),
      }));
    } catch (err) {
      console.error("Failed to remove committee", err);
      alert("Failed to remove committee.");
    }
  };


  return (
    <div className="section-box ">
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">Sections</h1>
        {Sections && Sections.some((s: ISection) => s.isSelected) ? (
          <PageLink onClick={() => setSessionEditModalOpen(true)}>
            Edit
          </PageLink>
        ) : (
          <span
            style={{ opacity: 0.5, cursor: "not-allowed", fontWeight: "500" }}
            title="No active sections to remove. To add sections, please create a new order."
          >
            Edit
          </span>
        )}
        {/* <div className="secondary-button1">
          <Link to="/order/create-order" className="menubar-link">
            <ButtonWithIcon
              icon={<OrderIcon height={25} width={25} />}
              buttontext="Create Order"
              onClick={createOrder}
            />
          </Link>
        </div> */}
      </div>
      <div className="form-wrapper overflow-auto">
        {typeof Sections != "undefined" ? (
          <div className="sections-section" key={sectionRefreshKey}>
            {Sections.map((section: ISection) =>
              IsActiveOrdersDataLoaded ? (
                <MDSectionsMultipleOptionItems
                  key={`${section.Id}-${sectionRefreshKey}`}
                  section={section}
                  membersActiveOrders={MembersActiveOrders}
                  lastYearSections={lastYearSections}
                  hasOfficerResponsibility={sectionOfficerResponsibility[section.Id] || false}
                  onOfficerResponsibilityChange={handleOfficerResponsibilityChange}
                  memberSectionId={(section as any).MemberSectionId || null}
                  availablePositions={availablePositions[section.Id] || []}
                  assignedPositions={memberPositions[(section as any).MemberSectionId] || []}
                  onAssignPosition={handleAssignPosition}
                  onRemovePosition={handleRemovePosition}
                  availableCommittees={availableCommittees[section.Id] || []}
                  assignedCommittees={memberCommittees[(section as any).MemberSectionId] || []}
                  onAssignCommittee={handleAssignCommittee}
                  onRemoveCommittee={handleRemoveCommittee}
                  // isSection={true}
                />
              ) : (
                <></>
              )
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
      {/* SessionEdit modal */}
      <ReactModal
        isOpen={sessionEditModalOpen}
        onRequestClose={() => setSessionEditModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Edit Section Information</h1>
          <PageLink onClick={() => setSessionEditModalOpen(false)}>
            Cancel
          </PageLink>
        </div>
        <>
          {typeof Sections != "undefined" ? (
            <div className="sections-section">
              <div>
                <p>
                  Select sections to remove.
                  <strong style={{ fontWeight: 500 }}>&nbsp;Note:&nbsp;</strong>
                  <span style={{ fontStyle: "italic", opacity: 0.8 }}>
                    To add sections, please create a new order.
                  </span>
                </p>
              </div>
              {Sections.filter((section: ISection) => section.isSelected)
                .length === 0 ? (
                <div style={{ textAlign: "center" }}>
                  No active sections to remove.
                </div>
              ) : (
                Sections.filter((section: ISection) => section.isSelected).map(
                  (section: ISection) => (
                    <MDEditSectionMultipleOptionItems
                      key={section.Id}
                      section={section}
                      onChangeFunction={handleChange}
                      isAdvanceOrder={false}
                      isAddSectionFlow={false}
                    />
                  )
                )
              )}
            </div>
          ) : (
            <></>
          )}
        </>
        <div className="button-wrapper">
          <div className="submit-button-div ">
            <Button
              type="submit"
              onClick={onSaveSections}
              disabled={
                Sections.filter((s: ISection) => s.isSelected).length === 0
              }
            >
              Save
            </Button>
          </div>
        </div>
      </ReactModal>
      {/* createOrderModal */}
      <ReactModal
        isOpen={createOrderModalOpen}
        onRequestClose={() => setCreateOrderModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Create Order</h1>
          <PageLink onClick={handleCancel}>Cancel</PageLink>
        </div>
        <form
          className="form-wrapper"
          onSubmit={handleSubmitPI(onSubmitOrderInfo)}
          noValidate
        >
          <div className="input-field-div-wrapper">
            <Label>Order Date</Label>
            <input
              className="input-field-div input-disabled"
              id="OrderDate"
              name="OrderDate"
              value={dayjs().format("YYYY-MM-DD")}
              disabled={true}
            />
          </div>
          <div
            className="horizontal-wrapper-spacebetween-center"
            style={{ width: "48%" }}
          >
            <>
              <label className="orderitem-header">MemberShip Code</label>
              <div className="horizontal-wrapper-rightaligned">
                <label className="orderitem-label">
                  {orderItem.MemberCode}
                  {orderItem.MemberCode ? "-" : null}
                  {toCamelCase(orderItem.MemberCodeDesc ?? "")}
                </label>
                <label
                  style={{
                    width: "10%",
                    paddingLeft: "0.5rem",
                  }}
                >
                  :
                </label>
                <span className="orderitem-value">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(orderItem.MemberCodeFee as number)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "left",
                }}
              >
                <label className="orderitem-header">Sections</label>
                <label
                  style={{
                    marginTop: "0.4rem",
                  }}
                >
                  (suggested)
                </label>
              </div>
              {Sections &&
                Sections.map((sectionItems: ISection) =>
                  selectedItems && selectedItems.includes(sectionItems.Id) ? (
                    <>
                      <div className="horizontal-wrapper-rightaligned">
                        <label className="orderitem-label">
                          {sectionItems.SectionName}
                        </label>
                        {/* <label
                          style={{
                            width: "10%",
                            paddingLeft: "0.5rem",
                          }}
                        >3
                          :
                        </label> */}
                        {/* <span className="orderitem-value">
                          {Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(sectionItems.Fee as number)}
                        </span> */}
                      </div>
                    </>
                  ) : (
                    <></>
                  )
                )}
              <div
                className="order-totalorder"
                style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
              >
                <span className="orderitem-label"> TOTAL AMOUNT </span>
                <label style={{ width: "10%", paddingLeft: "0.5rem" }}>:</label>
                <span className="orderitem-value">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(totalAmount)}
                </span>
              </div>
            </>
          </div>

          {currentMember.MemberCodeId === 21 ||
          currentMember.MemberCodeId === 22 ? (
            <div className="order-checkboxgroup">
              <input
                id="NoInvoiceFlag"
                name="NoInvoiceFlag"
                className="checkbox"
                type="checkbox"
                // onChange={(e) => updatePaymentInfo(e)}
                // disabled={true}
                readOnly={
                  currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
                  currentMember.MemberCodeId === 21 ||
                  currentMember.MemberCodeId === 22
                    ? true
                    : false
                }
                checked={
                  currentMember.MemberTags?.some((tag) => tag.Id === 44) ||
                  currentMember.MemberCodeId === 21 ||
                  currentMember.MemberCodeId === 22
                    ? true
                    : false
                }
              />
              <div>
                <span>
                  No Invoice
                  {currentMember.MemberCodeId === 21 ||
                  currentMember.MemberCodeId === 22 ? (
                    <span style={{ color: "red" }}>
                      {" "}
                      ({currentMember.Description})
                    </span>
                  ) : null}
                </span>
              </div>
            </div>
          ) : null}
          <div
            className="horizontal-wrapper-spaceevenly"
            style={{ marginTop: "2rem", marginBottom: "0.5rem" }}
          >
            {/* <div
              className="button-wrapper"
              style={{
                width: "100%",
                marginTop: "2rem",
                marginBottom: "100px",
              }}
            > */}
            {/* <div className="submit-button-div">
              <Button
                type="submit"
                onClick={onSubmitViewMember}
                style={{ background: "#fad478", color: "#000000" }}
              >
                View Member
              </Button>
              
            </div> */}
            <div className="submit-button-div ">
              <Button
                type="submit"
                // onClick={onSubmit}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </ReactModal>

      {/* ViewInvoiceModal */}
      <ReactModal
        isOpen={viewInvoiceModalOpen}
        onRequestClose={() => {
          handleCancelViewInvoiceModal();
        }}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">View INVOICE</h1>
          <div className="d-flex" style={{ width: "30%" }}>
            <div className="secondary-button">
              <Button type="submit" onClick={handleCancelViewInvoiceModal}>
                Close
              </Button>
            </div>
            <div className="secondary-button">
              <Button type="submit" onClick={handleSendInvoice}>
                Email Invoice
              </Button>
              {/* </div> */}
            </div>
          </div>
          <div className="pdf-container">
            <iframe
              src={invoiceURL}
              allow="autoplay"
              loading="lazy"
              title="Membership Invoice PDF"
            ></iframe>
          </div>
        </div>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default MDSections;
